import { render, staticRenderFns } from "./SpkDialog.vue?vue&type=template&id=5435fae9&"
import script from "./SpkDialog.vue?vue&type=script&lang=js&"
export * from "./SpkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports